import { InstagramLogoIcon, LinkedInLogoIcon } from '@radix-ui/react-icons';
import { Link } from 'react-router-dom';
import { openInExternalUrl } from 'helpers/utils';
import { FacebookIcon, SpotifyIcon, YouTubeIcon } from './SocialIcons';

export const Footer: React.FC = () => (
  <footer className='mx-5 my-36 flex flex-col gap-5 md:mx-0'>
    <div className='flex flex-row items-center justify-center gap-5 text-center'>
      <div
        className='text-accent-accent-9 cursor-pointer'
        onClick={() => openInExternalUrl('https://www.facebook.com/tennistalker/')}
      >
        <FacebookIcon />
      </div>
      <div
        className='text-accent-accent-9 cursor-pointer'
        onClick={() => openInExternalUrl('https://www.youtube.com/channel/UCk-SHhxRTu539b0qKuz5WUQ')}
      >
        <YouTubeIcon />
      </div>
      <div
        className='text-accent-accent-9 cursor-pointer'
        onClick={() => openInExternalUrl('https://open.spotify.com/show/39VEuj1IqIHzzir9Sf8tV0')}
      >
        <SpotifyIcon />
      </div>
      {/* <a
          className='mx-5 text-accent-accent-9 cursor-pointer'
          href='https://twitter.com/tennistalkerweb'
        >
          <TwitterLogoIcon />
        </a> */}
      <div
        className='text-accent-accent-9 cursor-pointer'
        onClick={() => openInExternalUrl('https://www.instagram.com/tennistalker.it/')}
      >
        <InstagramLogoIcon />
      </div>
      <div
        className='text-accent-accent-9 cursor-pointer'
        onClick={() => openInExternalUrl('https://www.linkedin.com/company/tennistalker/')}
      >
        <LinkedInLogoIcon />
      </div>
    </div>
    <div className='flex flex-col gap-2 text-center text-sm md:gap-1'>
      <div className='font-bold'>
        Copyright {new Date().getFullYear()} &copy;{' '}
        <span
          onClick={() => openInExternalUrl('https://it.linkedin.com/company/tennistalker')}
          title='TennisTalker S.R.L.'
          className='text-accent-accent-9 cursor-pointer'
        >
          TennisTalker S.r.l. Tutti i diritti sono riservati
        </span>{' '}
        - Contatti:{' '}
        <Link className='text-accent-accent-9' to='/contattaci'>
          info@tennistalker.it
        </Link>
      </div>
      <div>TennisTalker S.r.l. • Via Tintoretto, 5 - 20145 Milano (MI) • P.IVA/C.F.: 09787400960</div>
      <div>REA: MI - 2113270 • Capitale Sociale: 10.526,37 i.v. • Pec: tennistalker@legalmail.it</div>
      <div>Testata iscritta presso il tribunale di Milano n.131/2021</div>
      <div className='flex items-center justify-center gap-2'>
        <Link className='text-accent-accent-9' to='/condizioni-di-utilizzo'>
          Termini e condizioni
        </Link>
        -
        <Link className='text-accent-accent-9' to='/privacy-policy'>
          Privacy policy
        </Link>
        -
        {window.CookieScript?.instance?.show && (
          <a onClick={window.CookieScript.instance.show} className='text-accent-accent-9 cursor-pointer'>
            Consent Preferences
          </a>
        )}
      </div>
    </div>
  </footer>
);

export default Footer;
